import axiosInstance from '@/plugins/connectionBuilder.js'

export default {
    state: {
        periodicChecks: [],
        periodicCheckStatus: [],
        selectedCheck: null,
        checkHistory: [],
        isLoading: false,
    },
    mutations: {
        setPeriodicChecks(state, checks) {
            state.periodicChecks = checks
        },
        setPeriodicCheckStatus(state, status) {
            state.periodicCheckStatus = status
        },
        setSelectedCheck(state, check) {
            state.selectedCheck = check
        },
        setCheckHistory(state, history) {
            state.checkHistory = history
        },
        setPeriodicChecksLoading(state, isLoading) {
            state.isLoading = isLoading
        },
    },
    actions: {
        async getPeriodicChecks({ commit }, lift_id = null) {
            commit('setPeriodicChecksLoading', true)
            try {
                const response = await axiosInstance.post('/lifts/getPeriodicChecks', { lift_id })
                commit('setPeriodicChecks', response.data.message)
                return response.data
            } catch (error) {
                console.error('Error fetching periodic checks:', error)
                throw error
            } finally {
                commit('setPeriodicChecksLoading', false)
            }
        },

        async getPeriodicCheckStatus({ commit }, lift_id) {
            commit('setPeriodicChecksLoading', true)
            try {
                const response = await axiosInstance.post('/lifts/getPeriodicCheckStatus', { lift_id })
                commit('setPeriodicCheckStatus', response.data.message)
                return response.data
            } catch (error) {
                console.error('Error fetching periodic check status:', error)
                throw error
            } finally {
                commit('setPeriodicChecksLoading', false)
            }
        },

        async addPeriodicCheck({ dispatch }, payload) {
            try {
                const response = await axiosInstance.post('/lifts/addPeriodicCheck', payload)
                if (response.data.success) {
                    // Reload all checks after adding
                    await dispatch('getPeriodicChecks')
                    if (payload.lifts_selected && payload.lifts_selected.length > 0) {
                        // Also reload status for the first lift if specified
                        await dispatch('getPeriodicCheckStatus', payload.lifts_selected[0])
                    }
                }
                return response.data
            } catch (error) {
                console.error('Error adding periodic check:', error)
                throw error
            }
        },

        async deletePeriodicCheck({ dispatch }, payload) {
            try {
                const response = await axiosInstance.post('/lifts/deletePeriodicCheck', { check_id: payload.check_id })
                if (response.data.success) {
                    // Reload all checks after deleting
                    await dispatch('getPeriodicChecks')
                }
                return response.data
            } catch (error) {
                console.error('Error deleting periodic check:', error)
                throw error
            }
        },

        async recordPeriodicCheck({ dispatch }, payload) {
            try {
                const response = await axiosInstance.post('/lifts/recordPeriodicCheck', payload)
                if (response.data.success) {
                    // Reload status after recording
                    await dispatch('getPeriodicCheckStatus', payload.lift_id)
                    if (payload.check_id) {
                        await dispatch('getPeriodicCheckHistory', { check_id: payload.check_id, lift_id: payload.lift_id })
                    }
                }
                return response.data
            } catch (error) {
                console.error('Error recording periodic check:', error)
                throw error
            }
        },

        async getPeriodicCheckHistory({ commit }, payload) {
            try {
                const response = await axiosInstance.post('/lifts/getPeriodicCheckHistory', payload)
                commit('setCheckHistory', response.data.message)
                return response.data
            } catch (error) {
                console.error('Error fetching check history:', error)
                throw error
            }
        },

        async downloadPeriodicChecksPdf({ dispatch }, payload) {
            try {
                const response = await axiosInstance.post('/lifts/downloadPeriodicChecksPdf',
                    { lift_id: payload.lift_id },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        },
                        responseType: 'blob'
                    })
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const objectUrl = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.download = 'historiqueControlesPeriodiques' + (payload.lift_name ? '_' + payload.lift_name : '') + '.pdf'
                link.href = objectUrl
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(objectUrl)
            } catch (error) {
                console.error('Error downloading periodic checks PDF:', error)
                dispatch('addNotification', { message: 'Erreur lors du téléchargement du PDF', type: 'error' })
                throw error
            }
        },
    }
}
